import { useCallback } from 'react';
import type { AuthorizationParams } from '@auth0/auth0-react';
import { useAuth0 } from '@auth0/auth0-react';

/**
 * Returns a login-redirect trigger that brings the user back to the exact page
 * (path + query + hash) after the Auth0 round-trip. The returnTo is baked into
 * appState so no call site can forget it; the Auth0Provider's onRedirectCallback
 * restores location from appState.returnTo.
 */
export const useLoginAndReturn = () => {
  const { loginWithRedirect } = useAuth0();

  return useCallback(
    (authorizationParams?: AuthorizationParams) =>
      loginWithRedirect({
        ...(authorizationParams ? { authorizationParams } : {}),
        appState: {
          returnTo: window.location.pathname + window.location.search + window.location.hash,
        },
      }),
    [loginWithRedirect]
  );
};
